export default __webpack_public_path__ + "static/media/seven_content3.48672a26.png";